module.exports = __webpack_public_path__ + "img/icon-lightbulb.f3749dda.svg";